import { useState, useEffect, useRef } from "react";
import Abeille from "@/assets/Stimuli/Mvt_Obj_Couleur/Ampoule.gif";

const PoursuiteVisuelSmoothV2 = ({
  caseSize,
  vitesse, // Ajout du paramètre vitesse
}: {
  caseSize: number;
  vitesse: number; // 1 (lent), 2 (moyen), 3 (rapide)
}) => {
  const [isPaused, setIsPaused] = useState(false);
  const [isStarted, setIsStarted] = useState(true); // Track if the movement has started
  const [currentTarget, setCurrentTarget] = useState({ x: 0, y: 0 }); // Current target position
  const [nextTarget, setNextTarget] = useState({ x: 0, y: 0 }); // Next target position
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const gifRef = useRef(null); // Ref for GIF image
  const [isTestMode, setIsTestMode] = useState(false); // Test mode state
  // const canvasWidth = 16 * caseSize;
  // const canvasHeight = 12 * caseSize;
 const canvasWidth =  window.innerWidth;
  const canvasHeight = window.innerHeight;


  // Facteur de vitesse en fonction du niveau choisi (1 = lent, 2 = moyen, 3 = rapide)
  const speedFactor = vitesse === 1 ? 1 : vitesse === 2 ? 1.5 : 2;

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "t") {
        testGifPath();
      }
      if (event.key === "s") {
        startMovement();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [isPaused]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!document.fullscreenElement; // Check if in fullscreen mode
      setIsPaused(!isFullscreen);
    };

    // Add the event listeners for fullscreen and keydown
    window.addEventListener("fullscreenchange", handleFullscreenChange);

    // Clean up the event listeners when the component unmounts
    return () => {
      window.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);


  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    if (!context) return;
    const draw = () => {
      context.fillStyle = "black";
      context.fillRect(0, 0, canvasWidth, canvasHeight);
    };

    const moveTowardsTarget = () => {
      if (isStarted && !isPaused) {
        setCurrentTarget((prev) => {
          const dx = nextTarget.x - prev.x;
          const dy = nextTarget.y - prev.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 2) {
            generateNewTarget();
            return nextTarget;
          }

          const moveX = (dx / distance) * speedFactor; // Utiliser le facteur de vitesse
          const moveY = (dy / distance) * speedFactor;

          return { x: prev.x + moveX, y: prev.y + moveY };
        });
      }
    };

    const generateNewTarget = () => {
      const targetX = Math.floor(Math.random() * 16) * caseSize;
      const targetY = Math.floor(Math.random() * 12) * caseSize;
      setNextTarget({ x: targetX, y: targetY });
    };

    if (isStarted && !isPaused && nextTarget.x === 0 && nextTarget.y === 0) {
      generateNewTarget();
    }

    const intervalId = setInterval(() => {
      draw();
      moveTowardsTarget();
    }, 30); // Garder la même fréquence de rafraîchissement

    return () => clearInterval(intervalId);
  }, [
    currentTarget,
    canvasHeight,
    canvasWidth,
    isTestMode,
    isStarted,
    isPaused,
    nextTarget,
    speedFactor, // Mettre à jour en fonction de la vitesse
  ]);

  const testGifPath = () => {
    setIsTestMode(true);
    setTimeout(() => setIsTestMode(false), 2000); // Show the GIF in test mode for 2 seconds
  };

  const startMovement = () => {
    setIsStarted(true);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black", // backgroundColor prop passed here
      }}
    >
      <div
        style={{
          position: "relative",
          width: canvasWidth,
          height: canvasHeight,
        }}
      >
        <canvas
          ref={canvasRef}
          width={canvasWidth}
          height={canvasHeight}
          style={{ position: "absolute", top: 0, left: 0 }}
        />
        <img
          ref={gifRef}
          src={Abeille}
          alt="animated gif"
          style={{
            position: "absolute",
            left: isTestMode ? (canvasWidth - 50) / 2 : currentTarget.x,
            top: isTestMode ? (canvasHeight - 50) / 2 : currentTarget.y,
            width: canvasHeight/12,
            height: canvasHeight/12,
            transition: "left 0.03s linear, top 0.03s linear", // Smooth movement
          }}
        />
        <div>{isPaused ? "Paused" : ""}</div>
      </div>
    </div>
  );
};

export default PoursuiteVisuelSmoothV2;
